import React from 'react'
import styled from '@emotion/styled'

import MainMenu from '../MainMenu'
import UserStats from '../UserStats'

import logoImg from './logo.svg'

const Root = styled.div`
  padding-bottom: 11px;
`

const Top = styled.div`
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.8);
`

const LogoLink = styled.a`
  display: block;
  border: none;
  padding: 2px 18px 0 18px;
`

const Logo = styled.img`
  width: 60px;
  height: 45px;
`

const HeaderRoot = ({currentUser}) => <Root>
  <Top>
    <LogoLink href="https://mageric.life/main.asp?WW_ID=26745"><Logo src={logoImg}/></LogoLink>
    <UserStats currentUser={currentUser}/>
  </Top>
  <MainMenu/>
</Root>

export default HeaderRoot
